import { Component, OnInit } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-issue',
  templateUrl: './issue.component.html',
  styleUrls: ['./issue.component.scss']
})
export class IssueComponent implements OnInit {
  cdsFileSrc;
  constructor(

    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    if (environment.contextEnv == 'local'){
      this.cdsFileSrc =  this.sanitizer.bypassSecurityTrustResourceUrl('cds.html');
    } else if (environment.contextEnv == 'staging') {
      this.cdsFileSrc =  this.sanitizer.bypassSecurityTrustResourceUrl('cds-qa.html');
    } else if (environment.contextEnv == 'prod') {
      this.cdsFileSrc =  this.sanitizer.bypassSecurityTrustResourceUrl('cds-prod.html');
    } else if (environment.contextEnv == 'uat') {
      this.cdsFileSrc =  this.sanitizer.bypassSecurityTrustResourceUrl('cds-uat.html');
    }
    // if(localStorage.getItem('loginUserData') &&
    // (JSON.parse(localStorage.getItem('loginUserData'))['roleId']== '2' || JSON.parse(localStorage.getItem('loginUserData'))['roleId']== '1'))
    // else
    //   this.router.navigate(['/']);
  }

}
